module.exports = __webpack_public_path__ + "img/475.3cef183e.png";